export const styleByLang = stylesObj => propName => {
  const lang = window.CURRENT_LANGUAGE

  return stylesObj?.[lang]?.[propName] || stylesObj.default?.[propName]
}
